import { FC } from 'react';
import { Center, HStack, VStack, Spacer, StackProps } from '@chakra-ui/react';
import Logo from 'assets/logo.png';
import { APP_ROUTES } from 'constants/appRoutes';
import { SideNavLink } from 'components/atoms/SideNavLink';

type Props = {
  width: StackProps['width'];
};

export const SideNav: FC<Props> = ({ width }) => (
  <VStack
    bgColor="brand"
    overflowY="auto"
    w={width}
    h="100%"
    position="fixed"
    top={0}
    left={0}
    bottom={0}
    align="start"
    spacing={0}
  >
    <HStack p={5}>
      <Center>
        <img src={Logo} width="148px" alt="logo" />
      </Center>
    </HStack>
    <VStack m={0} w="100%">
      <SideNavLink to={APP_ROUTES.CUSTOMER}>顧客管理</SideNavLink>
      <SideNavLink to={APP_ROUTES.MENU_CATEGORY}>メニュー管理</SideNavLink>
      <SideNavLink to={APP_ROUTES.CRAWLER}>クローラー管理</SideNavLink>
      <SideNavLink to={APP_ROUTES.APIKEYTEMPLATE}>
        APIキー
        <br />
        テンプレート管理
      </SideNavLink>
      <SideNavLink to={APP_ROUTES.NOTIFICATION}>お知らせ管理</SideNavLink>
      <SideNavLink to={APP_ROUTES.RELEASE}>リリース管理</SideNavLink>
    </VStack>
    <Spacer />
    <Center
      p={5}
      color="rgba(255, 255, 255, 0.2)"
      fontSize={12}
      fontWeight="bold"
      width="100%"
    >
      Copyright © Hogetic Lab
    </Center>
  </VStack>
);
